export const DOMAIN_FORM_SUBMISSIONS = "FORM_SUBMISSIONS";
